import styled from 'styled-components';
import Text from 'shared/components/Text/Text';

export const LegalBodyTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 4px;
`;

export const StrongText = styled(Text)`
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
  display: inline;
  word-break: break-word;
`;

export const LegalBodyCheckboxContainer = styled.div`
  padding-right: 20px;
`;
